import $ from 'jquery';
window.$ = window.jQuery = $;

import 'select2';

import 'bootstrap';

import 'datatables.net-bs4';
import 'datatables.net-responsive-bs4';
